module.exports = __webpack_public_path__ + "img/0044.d2d035cf.jpg";